export const environment = {
  production: false,
  apiUrl: 'https://qa.api.hoot.nest.buhoms.com',
  mainApiKey: 'Wf1=cz-m!fLKAD~Hbk#%QEPu1|Pd'
};